import { AppBar, Box, Button, Divider, Card, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Grid2, IconButton, List, ListItem, ListItemText, Paper, Slide, Table, TableCell, TableRow, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import SignInDialog from '../../components/common/SignInDialog';
import api from '../../redux/features/auth/axiosAuthHelper';
import { logout, refreshAccessToken } from '../../redux/features/auth/authSlice';
import colorConfigs from '../../configs/colorConfigs';
import { TransitionProps } from '@mui/material/transitions';
import assets from '../../assets';
import RareButton from '../../components/common/buttons/RareButton';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import FactoryIcon from '@mui/icons-material/Factory';
import EmailIcon from '@mui/icons-material/Email';
import versionConfig from '../../configs/versionConfig';

type Props = {}


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AboutPage = (props: Props) => {
  const productName = "NTD connect"
  const version = versionConfig.version
  const manufacturedate = versionConfig.manufactureDate
  const address = "9909 Huennekens St.,"
  const address2 = "Suite 100,"
  const address3 = "San Diego, California, 92121, United States"

  const authData = useSelector((state: RootState) => state.auth);


  return authData.isAuthenticated == false ? (
    <SignInDialog isAuthenticated={authData.isAuthenticated} />
  ) : authData.isAuthenticated ? (
    <div style={{ overflowX: "hidden", maxHeight: `100%`, minHeight: `100%`, maxWidth: `100%`, minWidth: `100%`, margin: "auto" }}>

      <div style={{ display: "flex", height: "100%", width: "100%", maxWidth: `100%`, minWidth: `100%`, }}>

        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ m: 0, height: "100%", width: "100%", maxWidth: `100%`, minWidth: `100%`, }}
        >
          <Grid item xs={3} sx={{ m: 0, p: 0, maxWidth: `100%`, minWidth: `100%` }}>
            <Box sx={{ m: 0, p: 3, height: "100%", overflowY: "auto", marginRight: 0, display: 'flex', flexDirection: 'column', overflowX: "hidden", maxWidth: `93vw`, minWidth: `100%` }}>

              {/* <Typography variant="h1">About Page</Typography> */}

              <div style={{ paddingTop: '20px', display: "flex", alignItems: "center", height: "100%" }}>

                <Grid2
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ ml: 15, pl: 15 }}
                >
                  <Grid2 size={{ xs: 12 }}>
                    <Box sx={{ width: '100%', maxWidth: 1500 }}>
                      <Box sx={{ maxWidth: 600, ml: -6, pt: 2, mb: -2 }}>
                        <Typography variant="h5" gutterBottom align="left" sx={{ fontWeight: 'bold', color: colorConfigs.dashboard.dark_red }} >
                          {productName}
                        </Typography>
                      </Box>
                      <Table sx={{ maxWidth: 800, align: "left", ml: -8 }} border-collapse="collapse">
                        <TableRow style={{ borderBottom: 'none' }}>
                          <TableCell><Typography variant="body1" gutterBottom> </Typography></TableCell>
                          <TableCell><Typography variant="body1" gutterBottom> </Typography></TableCell>
                        </TableRow>
                        <TableRow style={{ borderBottom: 'none' }}>
                          <TableCell><Typography sx={{ fontWeight: 1000, color: colorConfigs.dashboard.dark_red }}>Version:</Typography></TableCell>
                          <TableCell><Typography variant="body1" gutterBottom>{version}</Typography></TableCell>
                        </TableRow>
                        <TableRow style={{ borderBottom: 'none' }}>
                          <TableCell><img src={assets.images.ISOManufactureDate} alt="reficon" style={{ aspectRatio: 1 / 1 }} /></TableCell>
                          <TableCell><Typography variant="body1" gutterBottom>{manufacturedate}</Typography></TableCell>
                        </TableRow>
                        <TableRow style={{ borderBottom: 'none' }}>
                          <TableCell><img src={assets.images.ISOManufacturedBy} alt="reficon" style={{ aspectRatio: 1 / 1, width: "33px" }} /></TableCell>
                          <TableCell>
                            <Typography variant="body1" gutterBottom>{address}</Typography>
                            <Typography variant="body1" gutterBottom>{address2}</Typography>
                            <Typography variant="body1" gutterBottom>{address3}</Typography>
                          </TableCell>
                        </TableRow>
                      </Table>
                      <Box sx={{ maxWidth: 600, ml: -6, pt: 2 }}>
                        <Typography variant="h5" gutterBottom align="left" sx={{ fontWeight: 'bold', color: colorConfigs.dashboard.dark_red }} >
                          Intended purpose
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          The App is intended to interpret rapid diagnostic tests (RDTs) for neglected tropical diseases (NTDs) prevalent in low-income settings. It aids in the surveillance of Lymphatic filariasis (LF) and Onchocerciasis of all ages residing in defined geographic areas.
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                          The app serves as a reader, providing its interpretation to healthcare workers or representatives of health programs as a basis for treatment. Results are transmitted to this cloud-based portal for real-time sharing with authorized stakeholders.
                        </Typography>
                        <br />
                        <Typography sx={{ fontWeight: 'bold' }}>For Performance Evaluation purposes only</Typography>
                      </Box>
                      <Divider sx={{ ml: -8, pt: 2 }} />
                      <Table sx={{ maxWidth: 400, align: "left", ml: -8 }}>
                        <TableRow style={{ borderBottom: 'none' }}>
                          <TableCell>
                            <RareButton
                              variant="outlined"
                              onClick={() => window.open('https://www.ddtd.org/terms-conditions', '_blank')}
                            >
                              Terms and Conditions
                            </RareButton>
                          </TableCell>
                          <TableCell>
                            <RareButton
                              variant="outlined"
                              onClick={() => window.open('https://www.ddtd.org/privacy-notice', '_blank')}
                            >
                              Privacy Notice
                            </RareButton>
                          </TableCell>
                        </TableRow>
                      </Table>

                    </Box>
                  </Grid2>
                </Grid2>
              </div>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  ) : (null);
};
export default AboutPage;

